// TODO ES-3805 - reuse after monorepo of shop and basket is done
export const useWindowSetter = (functionsForWindow: Record<string, (arg0: string) => void>) => {
  const setWindowFunc = () => Object.entries(functionsForWindow).forEach(([funcName, func]) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window[funcName] = func;
  });

  return [setWindowFunc];
};
